module.exports = __webpack_public_path__ + "static/media/rightBackground.5dee1b76.png";